import { cn } from "utils/cn";

type UserMessageProps = {
  children?: React.ReactNode;
  isHidden?: boolean;
};

export function UserMessage({ children, isHidden = false }: UserMessageProps) {
  return (
    <p
      className={cn(
        "ml-5 animate-fadeIn whitespace-pre rounded-xl border border-zi-lightGray bg-zi-white p-5 font-sans text-base text-zi-text empty:hidden",
        {
          hidden: isHidden,
          flex: !isHidden,
        }
      )}
    >
      {children}
    </p>
  );
}
